import { DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";

interface TermsPopProps {
    handleAgree: () => void;
}

export default function TermsPop({ handleAgree }: TermsPopProps) {
    return (
        <DialogContent className="block w-[calc(100%-40px)] max-w-[700px] gap-0 overflow-hidden rounded-[20px] bg-[#F7F6FB] p-0 [&>button>svg]:h-8 [&>button>svg]:w-8 [&>button]:right-[30px] [&>button]:top-6 [&>button]:z-[1] [&>button]:opacity-100 [&>button]:!ring-0 [&>button]:!ring-offset-0">
            <DialogTitle className="relative z-[1] border-b border-[#ddd] p-[24px_65px_16px_40px] text-[24px] font-[700]">
                개인정보 수집방침
            </DialogTitle>
            <ScrollArea className="max-h-[60vh] p-[24px_40px_0_40px]">
                <div className="whitespace-pre-line text-[18px] text-[#666]">{`[ 개인정보 수집 및 이용 동의 ]

GXG 운영사무국은 문의사항 확인 및 회신을 위해 다음과 같이 최소한의 개인정보(이름, 이메일, 전화번호, 문의내용)를 수집합니다. 수집된 정보는 행사 관련 문의 응대 외의 용도로 사용되지 않으며, 처리 후 안전하게 파기됩니다.

• 수집 항목: 이름, 이메일, 전화번호, 문의내용
• 이용 목적: 문의 사항 확인 및 응답
• 보유/이용 기간: 문의 처리 및 추후 응대를 위해 수집일로부터 최대 1년간 보관 후 파기

귀하는 해당 정보를 제공하지 않으실 권리가 있으며, 동의하지 않을 경우 문의사항 처리에 제약이 있을 수 있습니다.

위 내용을 확인했으며, 개인정보 수집 및 이용에 동의합니다.`}</div>
            </ScrollArea>
            <div className="p-[24px_0_40px]">
                <button
                    type="button"
                    className="relative mx-auto block h-[72px] w-[320px] border border-black bg-black text-center font-['GongGothicMedium'] text-[20px] leading-[72px] text-white clip-path-octagon"
                    onClick={handleAgree}
                >
                    <span>동의</span>
                    <span className="absolute left-0 top-0 border-[8px] border-black border-b-transparent border-r-transparent" />
                    <span className="absolute bottom-0 left-0 border-[8px] border-black border-r-transparent border-t-transparent" />
                    <span className="absolute right-0 top-0 border-[8px] border-black border-b-transparent border-l-transparent" />
                    <span className="absolute bottom-0 right-0 border-[8px] border-black border-l-transparent border-t-transparent" />
                </button>
            </div>
        </DialogContent>
    );
}
